import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
import moment from 'moment';
export default {
  name: 'ViewDigitalTwinDigitalTwinMap',
  mixins: [MapViewMixin, multiSearchMixin],
  data: function data() {
    return {
      active: null,
      historyFrom: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    setBackRouteObj: function setBackRouteObj() {
      return this.$route.query.edit === 'true' ? {
        path: "/digitaltwin-mgmt/".concat(this.active)
      } : {
        path: '/digitaltwin-mgmt/',
        query: {
          active: this.active
        }
      };
    }
  }),
  watch: {
    historyFrom: function historyFrom() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    }
  },
  created: function created() {
    this.active = this.$route.params.twinId;
  },
  mounted: function mounted() {
    this.loadInitialData();
    this.historyFrom = moment(new Date()).subtract(2, 'months').unix(); // multi-data fetch in searchTypesMixin

    this.getMultiFilterData();
  },
  methods: {
    handleHistoryFromPicked: function handleHistoryFromPicked(dateObject) {
      this.historyFrom = dateObject.from;
    },
    breadCrumbsPath: function breadCrumbsPath() {
      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }, this.$i18n_t('DigitalTwin.VirtualDevice.map.title')];
    },
    // from multi-search-mixin, forward to cluster-request
    fetchList: function fetchList() {
      if (this.$refs && this.$refs.mapInstance) {
        this.$refs.mapInstance.debouncedRequestClusterRequest();
      }

      this.fetchGeoMetaInfos();
    },
    fetchGeoMetaInfos: function fetchGeoMetaInfos() {
      var _this = this;

      var selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      return ApiService.digitalTwinFetchGeoMetaInfos(this, selectedRootTwinId, searchItems).then(function (data) {
        _this.stateKeys = data.keyList;
        _this.twinTags = data.tagList;
        _this.floorList = data.floorList;
      }).catch(function (error) {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    fetchTwinData: function fetchTwinData() {
      this.hasLoadedInitially = false;

      if (this.$refs.mapInstance) {
        this.$refs.mapInstance.hasLoadedMarkers = false;
      }

      this.loadTree();
      return this.fetchGeoMetaInfos();
    },
    getClusterContent: function getClusterContent(cluster, bounds) {
      var _this2 = this;

      if (!cluster) {
        this.selectedCluster = {};
        return;
      }

      var selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      ApiService.digitalTwinGetGeoClusterContent(this, cluster.id, selectedRootTwinId, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], searchItems, this.excludeZones).then(function (data) {
        _this2.selectedCluster = _objectSpread(_objectSpread({}, cluster), {}, {
          items: data.dtwins
        });
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree: function loadTree() {
      var _this3 = this;

      var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      var selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      return ApiService.digitalTwinFetchGeoClusters(this, selectedRootTwinId, this.indoorFloorDtwinId, bounds, this.selectedStateKey, searchItems, {
        excludeZones: this.excludeZones,
        hideStatelessPolygons: this.hideStatelessPolygons
      }).then(function (data) {
        _this3.calculateBoundingBox(data);

        _this3.markerItems = data.dtwins;
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      }).finally(function () {
        _this3.$store.state.app.loading = false;
      });
    }
  }
};